<template>
  <div class="container">
    <!-- 头部banner -->
    <top-banner></top-banner>
    <!-- 轮播 -->
    <img src="@/common/images/newsCenter/banner_news.png" class="banner_news" id="banner_news" />
    <!-- 占位撑开 -->
    <div class="zwnews"></div>
    <!-- 当前位置 -->
    <div class="cur">
      <img src="../common/images/newsCenter/more.png" class="more_img" />
      <span @click="go('')" style="cursor: pointer;">首页>></span>
      <span @click="go('newsCenter')" style="cursor: pointer;">新闻资讯>></span>
      <span>新闻详情页</span>
    </div>
    <!-- 新闻内容 -->
    <div class="news_contentA">
      <div class="detail_title">{{newsDetail.title}}</div>
      <div class="detail_time">{{newsDetail.createTime | dateFormat}}</div>
      <div class="detail_content" v-html="newsDetail.content"></div>
      <div class="detail_btm">
        <div class="btm_l" @click="goPre(preD.id)" v-if="preD!=null">上一篇：{{preD.title}}</div>
        <div class="btm_r" @click="goPre(nextD.id)" v-if="nextD!=null">下一篇：{{nextD.title}}</div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import topBanner from '@/components/topBanner.vue'
  export default {
    components: {
      topBanner,
    },
    data() {
      return {
        curPage:'newsCenter',
        newsDetail: {},
        preD: {},
        nextD: {},
        id: ''
      }
    },
    created() {
      this.id = this.$route.query.id
      this.getDetail(this.id)
      this.getPageBN(this.id)
    },
    methods: {
      getDetail(id) {
        var url = 'http://kjhsx.diandifenlei.com/RecycleBin/news/getNewsDetailsById'
        axios({
          method: 'get',
          url: url,
          params: {
            id: id
          }
        }).then(({
          data
        }) => {
          if (data.code == 200) {
            this.newsDetail = data.data
          }
        })
      },
      getPageBN(id) {
        var url = 'http://kjhsx.diandifenlei.com/RecycleBin/news/getPageNext'
        axios({
          method: 'get',
          url: url,
          params: {
            newsId: id
          }
        }).then(({
          data
        }) => {
          if (data.code == 200) {
            console.log(data.data)
            this.preD = data.data[0]
            this.nextD = data.data[1]
            // this.newsDetail = data.data
          }
        })
      },
      go(e) {
        this.$router.push({
          path: '/' + e
        })
      },
      goPre(e) {
        console.log(e)
        this.id = e
        this.getDetail(e)
        this.getPageBN(e)
        document.getElementById('banner_news').scrollIntoView()
      }
    }
  }
</script>

<style>
  .container {
    position: relative;
  }

  .banner_news {
    width: 1920px;
    height: 900px;
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .zwnews {
    width: 1920px;
    height: 900px;
  }

  .cur {
    width: 1280px;
    height: 60px;
    line-height: 60px;
    padding-top: 42px;
    margin: 0 auto;
    letter-spacing: 2px;
  }

  .more_img {
    width: 36px;
    height: 8px;
    margin-right: 18px;
  }

  .news_contentA {
    width: 1280px;
    min-height: 320px;
    margin: 32px auto;
    color: #000;
  }

  .detail_title {
    width: 1280px;
    height: 60px;
    line-height: 60px;
    font-size: 32px;
    text-align: center;
  }

  .detail_time {
    width: 1080px;
    height: 48px;
    line-height: 48px;
    font-size: 20px;
    text-align: right;
  }

  .detail_content {
    font-size: 24px;
    line-height: 1.5em;
    min-height: 300px;
    margin: 32px auto;
  }

  .detail_btm {
    width: 1280px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 22px;
    margin: 42px auto;
    position: relative;
  }

  .btm_l {
    width: 40%;
    padding: 12px 0;
    position: absolute;
    left: 0;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .btm_r {
    width: 40%;
    padding: 12px 0;
    position: absolute;
    right: 0;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>


// WEBPACK FOOTER //
// src/views/newsDetail.vue